import { Checkbox, CircularProgress } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { BOOKING_STAGES } from '../../../constants';
import { adminUpdateBooking } from '../../../services/apiService';
import { CustomContext } from '../page';

export default function CancelBooking({ booking, refreshData }) {
  const [refundCredits, setRefundCredits] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const { setSelectedAction } = useContext(CustomContext);

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsLoading(true);
      const payload = {
        id: booking.id,
        status: BOOKING_STAGES.CANCELLED.value,
        stage: BOOKING_STAGES.CANCELLED.value,
        deductUserCredits: refundCredits,
      };
      await adminUpdateBooking(payload);
      setSelectedAction(null);
      toast.success('Session cancelled');
      refreshData();
    } catch (e) {
      console.error(e);
      toast.error('Failed to cancel');
    }
  };

  return (
    <div className='fixed inset-0 bg-black bg-opacity-80 flex'>
      <div className='m-auto w-full max-w-2xl bg-white rounded p-5 relative'>
        <h6 className='text-lg opacity-80'>
          Are you sure you want to cancel this session?
        </h6>

        <button
          onClick={() => setSelectedAction(null)}
          className='absolute top-4 right-4'
        >
          <Close />
        </button>

        <p className='flex items-center text-sm -ml-2'>
          <Checkbox
            onChange={(e) => setRefundCredits(e.target.checked)}
            color='primary'
            checked={refundCredits}
          />
          <span className='opacity-60'>
            Refund booking credits to candidate
          </span>
        </p>

        <button
          onClick={handleSubmit}
          disabled={isLoading}
          className='bg-red-c1 text-white rounded w-48 py-1 mt-4 ml-auto flex justify-center'
        >
          {isLoading ? (
            <CircularProgress color='inherit' size='1.5rem' />
          ) : (
            <span>Confirm Cancellation</span>
          )}
        </button>
      </div>
    </div>
  );
}
